import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import TablaEstados from './TablaEstados';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';

const Alerta = (props) => {
    if (props.mostrar) {
        return <GenericAlert message="El proceso finalizo correctamente." type="success" />;
    } else {
        return null;
    }
}

class EdicionEstados extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            muestraComboCantidadProximoEstado: false
        };
    }

    componentDidMount() {

    }

    /**
     * 
     */
    btnEstadoAnterior() {
        this.props.siguenteEstado('ANTERIOR');
    }

    /**
     * 
     */
    btnSiguiente() {
        this.props.siguenteEstado('SIGUIENTE');
    }

    /**
     * 
     */
    btnFinalizar() {
        this.props.finalizarCreacion(this.props.data);
    }

    /**
     * 
     * @param {any} masDeUnProximoEstado
     */
    rdbEvent(masDeUnProximoEstado) {
        this.setState({ muestraComboCantidadProximoEstado: masDeUnProximoEstado });
        if (masDeUnProximoEstado) {
            this.props.actualizarCantidadEstadosSalida(2, this.props.data.estadoActual);
        } else {
            this.props.actualizarCantidadEstadosSalida(1, this.props.data.estadoActual);
        }
    }

    /**
     * 
     * @param {any} e
     */
    comboCantidadEstadosProximo(e) {
        this.props.actualizarCantidadEstadosSalida(e.target.value, this.props.data.estadoActual)
    }

    /**
     * 
     * @param {any} e
     */
    comboRequiereDocumentacion(e) {
        this.props.asignarDocumentacionAEstado(e.target.value, this.props.data.estadoActual);
    }

    /**
     * 
     * @param {any} event
     */
    cambiarEstadoSalida(event) {
        let nroEstado = event.target.id.replace('comboEstadoSalida_', '');
        this.props.asignarEstadoDeSalida(this.props.data.estadoActual, event.target.value, nroEstado);
    }

    render() {
        //Se cargan la informacion que poblara los combos...
        let cantidadEstados = [];
        let estados = null;
        let estadoData = this.props.data.estados;

        for (var i = 0; i < parseInt(this.props.data.cantidadEstados) - 2; i++) {
            cantidadEstados.push(<GenericOption key={i + 2} id={i + 2} description={i + 2} />)
        }

        let tiposDocumento = null;
        tiposDocumento = this.props.data.deliveryDocumentoTipo.map((tipoDoc) => {
            return (
                <GenericOption key={tipoDoc.Id} id={tipoDoc.Id} description={tipoDoc.Descripcion} />
            )
        })

        estados = this.props.data.deliveryestado.map((estado) => {
            let e = estadoData.find(x => x.EstadoInfo.Id == estado.Id);
            if (e !== undefined || estado.Id == 0) {
                return (
                    <GenericOption key={estado.Id} id={estado.Id} description={estado.Descripcion} />
                )
            }
        })

        let combosProximoEstado = [];
        let EstadoActual = this.props.data.estados.find(x => x.EstadoNumero == this.props.data.estadoActual);

        let cantidadEstadosSalida = 0;
        let muestraComboEdicion = false;
        if (EstadoActual !== undefined) {
            cantidadEstadosSalida = EstadoActual.cantidadEstadosSalida;

            for (var i = 0; i < cantidadEstadosSalida; i++) {
                combosProximoEstado.push(<div className="col-sm-4 div-padding-0"><label className="label-primary">Pr&oacute;ximo estado</label><br /><GenericSelect id={'comboEstadoSalida_' + i.toString()} className="form-control default-select combo-definicion-circuito-estados" options={estados} value={(!EstadoActual.EstadosSalida[i].hasOwnProperty('estadoId')) || (EstadoActual.EstadosSalida[i].hasOwnProperty('estadoId') && EstadoActual.EstadosSalida[i].estadoId === undefined) ? 0 : EstadoActual.EstadosSalida[i].estadoId} onChange={(e, nro) => this.cambiarEstadoSalida(e)} /></div>);
            }
        }

        return (
            <div>
                <Alerta mostrar={this.props.data.guardadoFinalizado} />
                <div className="div-definir-circuito-estados-combos">
                    <div className="divedicion-circuito-estados-table">
                        <TablaEstados data={this.props.data} />
                    </div>

                    <div className="divedicion-circuito-estados-info">
                        {/*Esdicion de estado*/}
                        <div className="NuevaTarjetaFormTitle">
                            <h3 className="quitar-margen">Definiciones paso</h3> <h3 className="color-header-numero-cuenta quitar-margen"><strong>{' ' + this.props.data.estadoActual}</strong></h3>
                        </div>

                        <br />
                        <div className="col-sm-12 div-padding-0">
                            {this.props.data.cantidadEstados <= 2 ? null : <div className="col-sm-4 div-padding-0">
                                {/*RadioButtons*/}
                                <form>
                                    <label className="label-primary">M&aacute;s de 1 estado pr&oacute;ximo</label>
                                    <div className="radio">
                                        <label className="label-primary">
                                            <input type="radio" value="option1" checked={this.state.muestraComboCantidadProximoEstado}
                                                onChange={(v) => this.rdbEvent(true)} />Si</label></div>
                                    <div className="radio">
                                        <label className="label-primary"><input type="radio" value="option2" checked={this.state.muestraComboCantidadProximoEstado === false}
                                            onChange={(v) => this.rdbEvent(false)} />No</label></div>
                                </form>
                            </div>}
                            {this.props.data.cantidadEstados <= 2 ? null :
                                <div className="col-sm-4 div-padding-0">
                                    {this.state.muestraComboCantidadProximoEstado ? <div><label className="label-primary">Cantidad</label><br />
                                        <GenericSelect id="selectEstado1" className="form-control default-select combo-definicion-circuito-estados" options={cantidadEstados.length == 0 ? null : cantidadEstados} value={cantidadEstadosSalida} onChange={(e) => this.comboCantidadEstadosProximo(e)} /></div> : null}
                                </div>
                            }
                            <div className="col-sm-4 div-padding-0">
                                <label className="label-primary">Requiere Documentaci&oacute;n</label>
                                <GenericSelect id="selectEstadoCircuito" className="form-control default-select combo-definicion-circuito-estados" options={tiposDocumento}
                                    value={EstadoActual.RequiereDocumentacion !== undefined ? EstadoActual.RequiereDocumentacion.Id : 0} onChange={(e) => this.comboRequiereDocumentacion(e)} />
                            </div>
                            <br />
                            <div className="col-sm-12 div-padding-0 div-estados-proximos">
                                {combosProximoEstado}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="div-definir-circuito-estados-boton">
                    <button id="btnComenzar" type="button" className="btn btn-secondary button-estados-anterior" onClick={() => this.btnEstadoAnterior()}>
                        Estado anterior
                    </button>
                    {
                        parseInt(this.props.data.cantidadEstados) == this.props.data.estadoActual ?
                            <button id="btnComenzar" type="button" className="btn btn-cta bto-finalizar-solicitud" onClick={() => this.btnFinalizar()}>
                                Finalizar
                    </button>
                            :
                            <button id="btnComenzar" type="button" className="btn btn-cta bto-finalizar-solicitud" onClick={() => this.btnSiguiente()}>
                                Siguiente
                    </button>
                    }
                </div>
            </div>
        );
    }
}

export default EdicionEstados;
